import React from 'react'
import { useCanSeeConversations } from '@ztechapps/chat.webui'
import { useRole } from '@ztechapps/common.hook'
import { panelpunchesPermissions } from '@ztechapps/panelpunches.common'
import { MenuItem } from '@ztechapps/webui.page'
import { ShowIf } from '@ztechapps/webui.util'
import { routesDef } from '../../../config/routes'
import { Nav } from 'react-bootstrap'
import styles from './style.module.scss'
import { SubMenuItem } from './SubMenuItem'
export const MenuBar = () => {
  const { canSeeConversations } = useCanSeeConversations()
  const { hasRole: canSeeOverview } = useRole({ roleName: panelpunchesPermissions.storeBack.canAccess.value })
  return (
    <Nav className={styles.topbar}>
      <ShowIf condition={canSeeOverview}>
        <MenuItem url={routesDef.OverviewPage.path} icon={'grip'} name={'Overview'} />
      </ShowIf>
      <SubMenuItem
        icon={'file-invoice-dollar'}
        name="Orders"
        subMenu={[
          { name: 'Sales', url: routesDef.OrdersPage.path, icon: 'file-invoice-dollar' },
          {
            name: 'Returns',
            url: routesDef.ReturnListItemPage.path,
            icon: 'right-left',
            otherPaths: [routesDef.ReturnDetailPage.path],
          },
          { name: 'Purchases', url: routesDef.PurchasesPage.path, icon: 'cart-shopping' },
        ]}
      />

      <SubMenuItem
        icon={'industry'}
        name="Manufacturing"
        subMenu={[
          { name: 'Projects', url: routesDef.ProjectsPage.path, icon: 'sitemap' },
          { name: 'Production', url: routesDef.ProductionPage.path, icon: 'industry' },
          { name: 'Logistics', url: routesDef.LogisticListPage.path, icon: 'truck-fast' },
          {
            name: 'Tasks',
            url: routesDef.TaskListPage.path,
            icon: 'clipboard-list',
            otherPaths: [routesDef.TaskItemPage.path, routesDef.TaskBoardPage.path, routesDef.TaskCalendarPage.path],
          },
        ]}
      />

      <SubMenuItem
        icon={'list-check'}
        name="Inventory"
        subMenu={[
          { name: 'Products', url: routesDef.ProductListPage.path, icon: 'boxes-packing' },
          { name: 'Adjustment', url: routesDef.AdjustmentPage.path, icon: 'scale-balanced' },
        ]}
      />

      <MenuItem icon={'users-between-lines'} name="Companies & Contacts" url={routesDef.ContactsPage.path} />

      <ShowIf condition={canSeeConversations}>
        <MenuItem url={routesDef.ConversationPage.path} icon={'inbox'} name={'Conversation'} />
      </ShowIf>

      <MenuItem url={routesDef.ReportPage.path} icon={'pie-chart'} name={'Reports'} />
    </Nav>
  )
}
